import React from "react";
// import StatCard from "../../../../../components/reusable/management/StatCard";
import StatsGrid from "../../../../../components/reusable/management/StatsGrid";

const cards = [
    {
        title: "Employees",
        value: 128,
        color: "#2563eb",
        icon: "users",
        subtitle: "Across all offices",
    },
    {
        title: "Departments",
        value: 5,
        color: "#10b981",
        icon: "briefcase",
        subtitle: "Active departments",
    },
    {
        title: "Offices",
        value: 3,
        color: "#f59e0b",
        icon: "building",
        subtitle: "Operating locations",
    },
    {
        title: "Managers",
        value: 14,
        color: "#8b5cf6",
        icon: "userCheck",
        subtitle: "Team leaders",
    },
    {
        title: "Active Teams",
        value: 12,
        color: "#06b6d4",
        icon: "layers",
        subtitle: "Currently working",
    },
    {
        title: "Working Today",
        value: 97,
        color: "#ef4444",
        icon: "activity",
        subtitle: "Employees online",
    },
];

const FirmStatsCards = () => {
    return (
        // <div className="stats-grid">
        //     {cards.map((card) => (
        //         <div key={card.title} >
        //             <StatCard
        //                 title    = { card.title }
        //                 value    = { card.value }
        //                 subtitle = { card.subtitle }
        //                 icon     = { card.icon }
        //                 color    = { card.color }
        //             />
        //         </div>
        //     ))}
        // </div>
        <StatsGrid cards = { cards } />
    );
};

export default FirmStatsCards;
